import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import HfReactHelper from 'common/utils/hf-react-helper';
import HelloModal from 'common/components/hello-modal';

const messages = defineMessages({
  title: {
    id: '',
    description: 'Title for limit quota alert modal',
    defaultMessage: 'Exceeded {type} quota',
  },
  pricing: {
    id: '',
    description: 'text for limit modal that lets you view our plans at their respective price',
    defaultMessage: 'View plans and pricing',
  },
  continue: {
    id: '',
    description: 'text for limit modal that lets you close the modal',
    defaultMessage: 'Close',
  },
});

type Props = {
  triggerType: () => void, // onSkip | onCancel
  children: React.ReactNode,
  type: string,
}

const QuotaAlert = ({ triggerType, children, type }: Props) => {
  const intl = useIntl();
  const pricingUrl = HfReactHelper.urlHelper('info/pricing', 'hellosign');
  const title = intl.formatMessage(messages.title, { type });

  return (
    <HelloModal
      width='540px'
      scrollable={false}
      isOpen={true}
      onRequestClose={triggerType}
      buttons={[
        {
          type: 'secondary',
          text: intl.formatMessage(messages.continue),
          onClick: triggerType,
        },
        {
          type: 'primary',
          text: intl.formatMessage(messages.pricing),
          buttonLink: pricingUrl,
          openInNewWindow: true,
        },
      ]}
      contentLabel={title}
    >
      {children}
    </HelloModal>
  );
};

export default QuotaAlert;
